// For TypeScript compatibility we import and export it this way
import * as _default from './MenuExport'
export { _default as default }
